import { observer } from 'mobx-react-lite'
import { appStore } from '../../index'
import { Pages } from '../../Stores/AppStore'
import { Home, ScanJob, ScanPositions, Confirmation, Assignment, PreviousAssignment } from './'

export const Router = observer(() => {
  switch (appStore.appState.page) {
    case Pages.Home:
      return <Home/>
    case Pages.ScanJob:
      return <ScanJob/>
    case Pages.ScanPositions:
      return <ScanPositions/>
    case Pages.Confirmation:
      return <Confirmation/>
    case Pages.Assignment:
      return <Assignment/>
    case Pages.PreviousAssignment:
      return <PreviousAssignment/>
  }
})
